import { useFindOneContactSentiment } from 'hooks/contact-sentiments';
import { useGetContactDetailsQuery } from 'services';
import { ContactDto } from 'types';

export function useContactDetail(contactId: number) {
  const { data: contactRes, isLoading } = useGetContactDetailsQuery(contactId!, {
    skip: !contactId,
    refetchOnMountOrArgChange: true
  });
  const { contactSentiment, isLoadingContactSentiment } = useFindOneContactSentiment(
    {
      idNumber: contactRes?.data?.idNumber,
      phoneNumber: contactRes?.data?.phoneNumber
    },
    {
      skip: !contactRes?.data?.phoneNumber
    }
  );

  return {
    contact: contactRes?.data
      ? ({
          ...contactRes.data,
          contactSentiment: contactSentiment || undefined
        } as ContactDto)
      : undefined,
    isLoading,
    isLoadingContactSentiment
  };
}
